<template>
   <div class="form-group">
        <label class="font-weight-bolder" for="url">
            {{ $t('webhook.titles.url') }}
        </label>
        <div class="d-flex">
            <input 
                type="url" 
                v-model="webhookUrl" 
                placeholder="https://example.com/example" 
                name="url" 
                class="form-control form-control-sm mr-3" 
                :class="{'border-danger': formErrors && formErrors?.url || errorMessage}"
                id="url" 
                inputmode="url"
                required>
            <button @click="testWebhookUrl()" class="btn btn-dark btn-sm" type="button">
                {{ $t('webhook.actions.testUrl') }}
            </button>
        </div>
        <div v-if="formErrors">
            <div v-for="message in formatedErrors" class="invalid-feedback d-flex">
                {{ message }}
            </div>
        </div>
        <div v-if="errorMessage" class="invalid-feedback d-flex">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import ProjectSettingsService from '@shared/modules/project-settings/project.settings.service';
import ProjectSettingsMessages from '@shared/modules/project-settings/project.settings.messages';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import HelperS from '@/shared-modules/services/helper.service';

export default {
    name: 'ProjectSettingWebhookUrl',
    props: {
        alias: {
            type: String,
            default: null
        },
        projectAlias: {
            type: String,
            default: null
        },
        value: {
            type: String, 
            default: ""
        }
    },
    data() {
        return {
            webhookUrl: "",
            errorMessage: null
        }
    },
    mounted() {
        if (this.value) {
            this.webhookUrl = this.value
        }
    },
    computed: {
        formErrors() {
            return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.PROJECT_SETTING_WEBHOOK_FORM_URL)
        },
        formatedErrors() {
            return HelperS.destructureObject(this.formErrors);
        }
    },
    methods: {
        testWebhookUrl() {
            this.resetErrors()
            ProjectSettingsService.testWebhookUrl(
                this.alias,
                this.projectAlias,
                {url: this.webhookUrl}
            ).then((res) => {
                if (res.status == 200) {
                    this.resetErrors() 

                    if (res.data?.responseCode == 404) {
                        this.errorMessage = res.data.responseBody
                    } else {
                        this.errorMessage = null
                    }
                }
            })
        },
        resetErrors() {
            this.$store.dispatch('setFormErrors', {
                formName: FORM_NAME_ENUMS.PROJECT_SETTING_WEBHOOK_FORM_URL,
                errors: null
            })
        }
    },
    i18n: {
        messages: ProjectSettingsMessages
    }
}
</script>